var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsMessageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_98_16399)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6853 20.57C14.6236 20.571 14.5619 20.5714 14.5 20.5714C8.97715 20.5714 4.5 16.8618 4.5 12.2857C4.5 7.70964 8.97715 4 14.5 4C20.0228 4 24.5 7.70964 24.5 12.2857C24.5 13.443 24.2136 14.5449 23.6964 15.5454C23.0025 16.9598 21.9315 18.2222 20.7697 19.3111C18.9996 20.9703 16.9515 22.2229 15.493 22.9287C15.1073 23.1155 14.6853 22.8231 14.6853 22.4159V20.57ZM11.0714 12.7143C11.0714 13.5033 10.4318 14.1429 9.64286 14.1429C8.85388 14.1429 8.21429 13.5033 8.21429 12.7143C8.21429 11.9253 8.85388 11.2857 9.64286 11.2857C10.4318 11.2857 11.0714 11.9253 11.0714 12.7143ZM14.5 14.1429C15.289 14.1429 15.9286 13.5033 15.9286 12.7143C15.9286 11.9253 15.289 11.2857 14.5 11.2857C13.711 11.2857 13.0714 11.9253 13.0714 12.7143C13.0714 13.5033 13.711 14.1429 14.5 14.1429ZM20.7857 12.7143C20.7857 13.5033 20.1461 14.1429 19.3571 14.1429C18.5682 14.1429 17.9286 13.5033 17.9286 12.7143C17.9286 11.9253 18.5682 11.2857 19.3571 11.2857C20.1461 11.2857 20.7857 11.9253 20.7857 12.7143Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 20.5714C20.0228 20.5714 24.5 16.8618 24.5 12.2857C24.5 7.70964 20.0228 4 14.5 4C8.97715 4 4.5 7.70964 4.5 12.2857C4.5 16.8618 8.97715 20.5714 14.5 20.5714ZM9.64286 14.1429C10.4318 14.1429 11.0714 13.5033 11.0714 12.7143C11.0714 11.9253 10.4318 11.2857 9.64286 11.2857C8.85388 11.2857 8.21429 11.9253 8.21429 12.7143C8.21429 13.5033 8.85388 14.1429 9.64286 14.1429ZM15.9286 12.7143C15.9286 13.5033 15.289 14.1429 14.5 14.1429C13.711 14.1429 13.0714 13.5033 13.0714 12.7143C13.0714 11.9253 13.711 11.2857 14.5 11.2857C15.289 11.2857 15.9286 11.9253 15.9286 12.7143ZM19.3571 14.1429C20.1461 14.1429 20.7857 13.5033 20.7857 12.7143C20.7857 11.9253 20.1461 11.2857 19.3571 11.2857C18.5682 11.2857 17.9286 11.9253 17.9286 12.7143C17.9286 13.5033 18.5682 14.1429 19.3571 14.1429Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_98_16399",
    x: 0.5,
    y: 0.33,
    width: 28,
    height: 26.9863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_98_16399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_98_16399",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsMessageIcon);
export default __webpack_public_path__ + "static/media/es_message_icon.027458539c3b6debdbe57f8855d995bc.svg";
export { ForwardRef as ReactComponent };